import {
  AppPromotionsGetFiles,
  CRAppPromotionsSummary,
  CRAppPromotionsUpdate,
} from "../../Server/ApiV2";

export const CRApp_Promotions_Summary = async (postData) => {
  try {
    const response = await CRAppPromotionsSummary(postData);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
export const AppPromotions_Get_Files = async (postData) => {
  try {
    const response = await AppPromotionsGetFiles(postData);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
export const CRAppPromotions_Update = async (postData) => {
  try {
    const response = await CRAppPromotionsUpdate(postData);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
